<template>
  <modal-wrapper
    ref="modalRef"
    :buttons-disabled="isChangingInspectorStatus"
    :close-on-ok-click="false"
    :display-cancel-button="!Boolean(results)"
    :header="$t('filesOverview.confirmStatusChanges')"
    :ok-button-label="
      results ? t('generic.ok') : t('filesOverview.confirmStatusChanges')
    "
    :size="ModalSize.L"
    @ok-button-click="handleModalOk"
    @hide="emit('hide')"
  >
    <template v-if="!results">
      <p v-if="statusChanges.statusChangeType === 'accepted'">
        {{ t('filesOverview.followingDocumentsWillBeAccepted') }}
      </p>

      <p v-if="statusChanges.statusChangeType === 'rejected'">
        {{ t('filesOverview.followingDocumentsWillBeRejected') }}
      </p>

      <ul v-if="statusChanges">
        <li v-for="file in statusChanges.files" :key="file.documentId">
          {{ file.documentId }}
        </li>
      </ul>

      <div id="confirmation-spinner-container">
        <spinner-wrapper
          v-if="isChangingInspectorStatus"
          :size="SpinnerSize.L"
        />
      </div>
    </template>

    <template v-else>
      <div v-if="results.successfullCount">
        {{
          t('filesOverview.inspectorStatusChangeSuccessfullFiles', {
            count: results.successfullCount,
            successfullCount: results.successfullCount,
          })
        }}
      </div>
      <div v-if="results.failedCount">
        {{
          t('filesOverview.inspectorStatusChangeFailedFiles', {
            count: results.failedCount,
            failedCount: results.failedCount,
          })
        }}
      </div>
    </template>
  </modal-wrapper>
</template>

<script lang="ts" setup>
  import { IInspectorStatusAssignmentResponseDto } from 'types';
  import { IStatusChanges } from '../FilesOverviewTable/FilesOverviewTable.types';
  import { useI18n } from 'vue-i18n';
  import { useModalWrapper } from '../ModalWrapper';
  import { ModalSize } from '../ModalWrapper/ModalWrapper.types';
  import { SpinnerSize } from '../SpinnerWrapper/SpinnerWrapper.types';

  const props = defineProps<{
    isChangingInspectorStatus: boolean;
    results?: IInspectorStatusAssignmentResponseDto;
    statusChanges: IStatusChanges | Record<string, never>;
  }>();
  const emit = defineEmits<{
    (e: 'hide'): void;
    (e: 'inspector-confirmation'): void;
  }>();

  const { t } = useI18n();

  const { modalRef, show, hide } = useModalWrapper();
  defineExpose({ show, hide });

  function handleModalOk() {
    if (props.results) {
      hide();
    } else {
      emit('inspector-confirmation');
    }
  }
</script>

<style scoped lang="scss">
  #confirmation-spinner-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
</style>
